// extracted by mini-css-extract-plugin
export default {"root":"_eBbJ","title":"Oh8TL","content":"XZ2zu","icon":"_nKrR","item":"U_crZ","close":"PU0RH","watchTutorial":"U_AJH","playIcon":"vIBbq"};